import { render, staticRenderFns } from "./PivotTable.vue?vue&type=template&id=013fbb17&scoped=true&"
import script from "./PivotTable.vue?vue&type=script&lang=js&"
export * from "./PivotTable.vue?vue&type=script&lang=js&"
import style0 from "./PivotTable.vue?vue&type=style&index=0&id=013fbb17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013fbb17",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
